var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRole(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 20,
    viewBox: "0 0 26 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.81643 9.2029C8.46667 9.2029 7.36232 8.77343 6.50338 7.91449C5.64444 7.05556 5.21498 5.95121 5.21498 4.60145C5.21498 3.25169 5.64444 2.14734 6.50338 1.28841C7.36232 0.429469 8.46667 0 9.81643 0C11.1662 0 12.2705 0.429469 13.1295 1.28841C13.9884 2.14734 14.4179 3.25169 14.4179 4.60145C14.4179 5.95121 13.9884 7.05556 13.1295 7.91449C12.2705 8.77343 11.1662 9.2029 9.81643 9.2029ZM0 19.05V16.1664C0 15.4506 0.178945 14.8013 0.536836 14.2185C0.894726 13.6356 1.41111 13.201 2.08599 12.9147C3.61981 12.2399 4.9849 11.7644 6.18128 11.4883C7.37766 11.2122 8.58937 11.0742 9.81643 11.0742C11.0435 11.0742 12.2501 11.2122 13.4362 11.4883C14.6224 11.7644 15.9824 12.2399 17.5162 12.9147C18.1911 13.2215 18.7126 13.6612 19.0807 14.2338C19.4488 14.8064 19.6329 15.4506 19.6329 16.1664V19.05H0Z",
    fill: "#4644B2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4968 11.657L21.485 9.34527L19.2246 8.3105L21.485 7.25371L22.4968 4.96399L23.5301 7.25371L25.7689 8.3105L23.5301 9.34527L22.4968 11.657Z",
    fill: "#4644B2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0557 6.30259L17.4052 4.76143L15.9521 4.07158L17.4052 3.36705L18.0557 1.84058L18.7199 3.36705L20.1592 4.07158L18.7199 4.76143L18.0557 6.30259Z",
    fill: "#4644B2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRole);
export default __webpack_public_path__ + "static/media/Role.8acd798245f63561a16b7a2a82511e9c.svg";
export { ForwardRef as ReactComponent };